import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import s from './Invoice.css';

class Invoice extends React.Component {
  static propTypes = {
    billAmount: PropTypes.string.isRequired,
    accountNumber: PropTypes.string.isRequired,
    recipient: PropTypes.string,
    establishment: PropTypes.string,
    currentAccount: PropTypes.string,
    swiftCode: PropTypes.string,
    paymentType: PropTypes.string,
    zkpo: PropTypes.string,
  };
  static defaultProps = {
    recipient: 'ФОП Швець Людмила Петрівна',
    establishment: 'Банк АТ "Райффайзен банк Аваль"',
    swiftCode: '380805',
    currentAccount: '26000147358',
    paymentType: 'Поповнення рахунку в системі avtobazar.ua',
    zkpo: '2720705249',
  };
  triggerPrint = target => {
    setTimeout(() => {
      if (target) {
        target.contentWindow.focus();
        target.contentWindow.print();
        this.removeWindow(target);
      }
    }, 500);
  };
  removeWindow = target => {
    setTimeout(() => {
      if (target) {
        target.parentNode.removeChild(target);
      }
    }, 500);
  };
  handlePrintClick = () => {
    const contentNodes = this.componentRef;
    const printWindow = document.createElement('iframe');
    printWindow.style.position = 'absolute';
    printWindow.style.top = '-1000px';
    printWindow.style.left = '-1000px';
    const defaultPageStyle =
      '@page { size: auto;  margin: 0mm; } ' +
      '@media print { body { ' +
      '-webkit-print-color-adjust: exact; ' +
      'padding: 10px; ' +
      '} }';
    const linkNodes = document.querySelectorAll('link[rel="stylesheet"]');
    this.linkTotal = linkNodes.length || 0;
    this.linkLoaded = 0;
    const markLoaded = () => {
      this.linkLoaded += 1;
      if (this.linkLoaded === this.linkTotal) {
        this.triggerPrint(printWindow);
      }
    };
    printWindow.onload = () => {
      if (window.navigator && window.navigator.userAgent.indexOf('Trident/7.0') > -1) {
        printWindow.onload = null;
      }
      const domDoc = printWindow.contentDocument || printWindow.contentWindow.document;
      domDoc.open();
      domDoc.write(contentNodes.outerHTML);
      domDoc.close();
      const styleEl = domDoc.createElement('style');
      styleEl.appendChild(domDoc.createTextNode(defaultPageStyle));
      domDoc.head.appendChild(styleEl);
      const headEls = document.querySelectorAll('style, link[rel="stylesheet"]');
      [...headEls].forEach((node, index) => {
        const newHeadEl = domDoc.createElement(node.tagName);
        let styleCSS = '';
        if (node.tagName === 'STYLE') {
          if (node.sheet) {
            for (let i = 0; i < node.sheet.cssRules.length; i += 1) {
              styleCSS += `${node.sheet.cssRules[i].cssText}\r\n`;
            }
            newHeadEl.setAttribute('id', `react-to-print-${index}`);
            newHeadEl.appendChild(domDoc.createTextNode(styleCSS));
          }
        } else {
          const attributes = [...node.attributes];
          attributes.forEach(attr => {
            newHeadEl.setAttribute(attr.nodeName, attr.nodeValue);
          });
          newHeadEl.onload = markLoaded.bind(null, 'link');
          newHeadEl.onerror = markLoaded.bind(null, 'link');
        }
        domDoc.head.appendChild(newHeadEl);
      });
      if (this.linkTotal === 0) {
        this.triggerPrint(printWindow);
      }
    };
    document.body.appendChild(printWindow);
  };
  render() {
    const {
      recipient,
      establishment,
      currentAccount,
      paymentType,
      zkpo,
      accountNumber,
      billAmount,
      swiftCode,
    } = this.props;

    return (
      <div className={s.root}>
        <div className={s.info}>
          <h1 className={s.h1}>
            <FormattedMessage id="Квитанция для оплаты" />
          </h1>
          <h4 className={s.h4}>
            <FormattedMessage id="Распечатайте квитанцию и оплатите в любом удобном для Вас банке" />
            .
          </h4>
          <p>
            <FormattedMessage id="Только для частных лиц" />.
            <br />
            <FormattedMessage id="Юридические лица могут связаться по email" />: sales@ab.ua
          </p>
          <button onClick={this.handlePrintClick} className={s.printButton}>
            <FormattedMessage id="Распечатать" />
          </button>
        </div>
        <div
          ref={el => {
            this.componentRef = el;
          }}
          className={s.tableContainer}
        >
          <table cellSpacing={0} cellPadding={0} className="st_all" id="odr">
            <tbody>
              <tr className="st_5">
                <td width="1%">&nbsp;</td>
                <td width="33%" className="st_r">
                  &nbsp;
                </td>
                <td width="1%">&nbsp;</td>
                <td width="43%">
                  <span className="f_8">Отримувач платежу</span>
                </td>
                <td width="10%">&nbsp;</td>
                <td width="1%">&nbsp;</td>
                <td width="10%">&nbsp;</td>
                <td width="1%">&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">
                  <span className="f_12 f_b">ПОВІДОМЛЕННЯ</span>
                </td>
                <td>&nbsp;</td>
                <td rowSpan={2} className="st_b bottom">
                  <span className="f_11 f_b">{recipient}</span>
                </td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td align="center" className="st_all">
                  <span className="f_11 f_b">{currentAccount}</span>
                </td>
                <td>&nbsp;</td>
                <td align="center" className="st_all">
                  <span className="f_11 f_b">{zkpo}</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td align="center" valign="top">
                  <span className="f_8">Поточний рахунок</span>
                </td>
                <td>&nbsp;</td>
                <td align="center" valign="top">
                  <span className="f_8">Код ЄДРПОУ</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td colSpan={2} valign="bottom">
                  <span className="f_8">Установа банку</span>
                </td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td colSpan={2} className="st_b">
                  <span className="f_11 f_b">{establishment}</span>
                </td>
                <td className="st_b">&nbsp;</td>
                <td className="st_all" align="center">
                  <span className="f_11 f_b">{swiftCode}</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td align="center" valign="top">
                  <span className="f_8">МФО банку</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td colSpan={2} className="st_b">
                  <span className="f_11 f_b">&nbsp;</span>
                </td>
                <td className="st_b">&nbsp;</td>
                <td className="st_all">&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td valign="top" colSpan={2}>
                  <span className="f_8">Прізвище, ім{"'"}я та по-батькові платника</span>
                </td>
                <td>&nbsp;</td>
                <td align="center" valign="top">
                  <span className="f_8">Ідентифікаційний номер</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td className="st_b">&nbsp;</td>
                <td className="st_b">&nbsp;</td>
                <td className="st_b">&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td className="st_b2">&nbsp;</td>
                <td className="st_b2" valign="top">
                  <span className="f_8">адреса платника</span>
                </td>
                <td className="st_b2">&nbsp;</td>
                <td className="st_b2">&nbsp;</td>
                <td className="st_b2">&nbsp;</td>
                <td className="st_b2">&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td colSpan={3} className="st_br">
                  <span className="f_8">Вид платежу</span>
                </td>
                <td align="center" className="st_b st_r">
                  <span className="f_8">Сумма</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td rowSpan={3} className="st_b" valign="top" colSpan={2}>
                  <span className="f_11 f_b">
                    {paymentType} (номер рахунку {accountNumber}). Без ПДВ.
                  </span>
                </td>
                <td className="st_r">&nbsp;</td>
                <td className="st_r" align="center">
                  <span className="f_11 f_b">{billAmount}</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td className="st_b st_r">&nbsp;</td>
                <td className="st_b st_r">&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td />
                <td />
                <td align="right">
                  <span className="f_8">Всього</span>
                </td>
                <td className="st_r">&nbsp;</td>
                <td className="st_b st_r" align="center">
                  <span className="f_11 f_b">{billAmount}</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">
                  <span className="f_11 f_b">Касир</span>
                </td>
                <td />
                <td>
                  <span className="f_8">Платник</span>
                </td>
                <td />
                <td />
                <td className="st_top">&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr className="st_5">
                <td className="st_bb">&nbsp;</td>
                <td className="st_bb st_r">&nbsp;</td>
                <td className="st_bb">&nbsp;</td>
                <td className="st_bb">&nbsp;</td>
                <td className="st_bb">&nbsp;</td>
                <td className="st_bb">&nbsp;</td>
                <td className="st_bb">&nbsp;</td>
                <td className="st_bb">&nbsp;</td>
              </tr>
              <tr className="st_5">
                <td width="1%">&nbsp;</td>
                <td width="33%" className="st_r">
                  &nbsp;
                </td>
                <td width="1%">&nbsp;</td>
                <td width="43%">
                  <span className="f_8">Отримувач платежу</span>
                </td>
                <td width="10%">&nbsp;</td>
                <td width="1%">&nbsp;</td>
                <td width="10%">&nbsp;</td>
                <td width="1%">&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">
                  <span className="f_12 f_b">КВИТАНЦІЯ</span>
                </td>
                <td>&nbsp;</td>
                <td rowSpan={2} className="st_b bottom">
                  <span className="f_11 f_b">{recipient}</span>
                </td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td align="center" className="st_all">
                  <span className="f_11 f_b">{currentAccount}</span>
                </td>
                <td>&nbsp;</td>
                <td align="center" className="st_all">
                  <span className="f_11 f_b">{zkpo}</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td align="center" valign="top">
                  <span className="f_8">Поточний рахунок</span>
                </td>
                <td>&nbsp;</td>
                <td align="center" valign="top">
                  <span className="f_8">Код ЄДРПОУ</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td colSpan={2} valign="bottom">
                  <span className="f_8">Установа банку</span>
                </td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td colSpan={2} className="st_b">
                  <span className="f_11 f_b">{establishment}</span>
                </td>
                <td className="st_b">&nbsp;</td>
                <td className="st_all" align="center">
                  <span className="f_11 f_b">{swiftCode}</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td align="center" valign="top">
                  <span className="f_8">МФО банку</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td colSpan={2} className="st_b">
                  <span className="f_11 f_b" />
                </td>
                <td className="st_b">&nbsp;</td>
                <td className="st_all">&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td valign="top" colSpan={2}>
                  <span className="f_8">Прізвище, ім{"'"}я та по-батькові платника</span>
                </td>
                <td>&nbsp;</td>
                <td align="center" valign="top">
                  <span className="f_8">Ідентифікаційний номер</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td className="st_b">&nbsp;</td>
                <td className="st_b">&nbsp;</td>
                <td className="st_b">&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td className="st_b2">&nbsp;</td>
                <td className="st_b2" valign="top">
                  <span className="f_8">адреса платника</span>
                </td>
                <td className="st_b2">&nbsp;</td>
                <td className="st_b2">&nbsp;</td>
                <td className="st_b2">&nbsp;</td>
                <td className="st_b2">&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td colSpan={3} className="st_br">
                  <span className="f_8">Вид платежу</span>
                </td>
                <td align="center" className="st_b st_r">
                  <span className="f_8">Сумма</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td rowSpan={3} className="st_b" valign="top" colSpan={2}>
                  <span className="f_11 f_b">
                    {paymentType} (номер рахунку {accountNumber}). Без ПДВ.
                  </span>
                </td>
                <td className="st_r">&nbsp;</td>
                <td className="st_r" align="center">
                  <span className="f_11 f_b">{billAmount}</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td className="st_b st_r">&nbsp;</td>
                <td className="st_b st_r">&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td />
                <td />
                <td align="right">
                  <span className="f_8">Всього</span>
                </td>
                <td className="st_r">&nbsp;</td>
                <td className="st_b st_r" align="center">
                  <span className="f_11 f_b">{billAmount}</span>
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="st_r">
                  <span className="f_11 f_b">Касир</span>
                </td>
                <td />
                <td>
                  <span className="f_8">Платник</span>
                </td>
                <td />
                <td />
                <td className="st_top">&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr className="st_5">
                <td>&nbsp;</td>
                <td className="st_r">&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Invoice);



// WEBPACK FOOTER //
// ./src/shared/components/Invoice/Invoice.js